export class Address {
    line1: string;
    line2: string;
    city: string;
    provinceCode: string;
    postalCode: string;
    countryCode: string;

    static get empty(): Address {
        return {
            line1: '',
            line2: '',
            city: '',
            provinceCode: '',
            postalCode: '',
            countryCode: '',
        };
    }
}
